var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-container',{staticClass:"custom",attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',[(_vm.currentUser)?[_c('headerbar',{attrs:{"app":"","showMenu":_vm.show}})]:_vm._e()],2)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('main',[_c('router-view')],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28597bd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 8N3P
// module chunks = 9